const axios = require('axios');
const base = 'https://api-dev.thirdfloor.ai/dev';


const login = async ( u, p ) => {
    const endpoint = base + '/login?';
    let user = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                user: u,
                pwd: p,
                action: 'login'
            },
            headers: {
                'tf-sid': 'ses_1234'
            }
		} );
        console.log( JSON.parse( resp.data.body ) );
        user = ( resp.data && resp.data.body && resp.data.body.length ) ? JSON.parse( resp.data.body ) : { password: false };
	} catch ( e ) {
		console.log( e );
	}

    return user;
};

const reload = async ( u ) => {
    const endpoint = base + '/login?';
    let user = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                user: u,
                action: 'reload'
            },
            headers: {
                'tf-sid': 'ses_1234'
            }
		} );
        // console.log( resp );
        user = ( resp.data && resp.data.body && resp.data.body.length ) ? JSON.parse( resp.data.body ) : { password: false };
	} catch ( e ) {
		console.log( e );
	}

    return user;
};

const restore = async ( u, s ) => {
    const endpoint = base + '/login?';
    let user = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                user: u,
                action: 'restore'
            },
            headers: {
                'tf-sid': s
            }
		} );
        // console.log( resp );
        user = ( resp.data && resp.data.body && resp.data.body.length ) ? JSON.parse( resp.data.body ) : { password: false, sid: '' };
	} catch ( e ) {
		console.log( e );
	}

    return user;
};

const loadAccounts = async () => {
    const endpoint = base + '/accounts?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.id,
                key: 'key:' + d.id,
                name: d.name,
                active: ( d.active ) ? 'Yes' : 'No',
                type: d.type,
                crm: d.crm.type,
                factory: d.crm.factory
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadUsers = async ( orgId, aid, uid, segment ) => {
    const endpoint = base + '/login?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                orgId: orgId,
                aid: aid,
                uid: uid,
                action: 'admin-load-users'
            },
            responseEncoding: 'gzip'
		} );
        console.log( 'loadUsers resp: ', resp.data );
        const data = ( resp.data && resp.data.body && resp.data.body.length ) ? JSON.parse( resp.data.body ) : [];
        console.log( 'loadUsers data: ', data );
        list = data.map( d => {
            return {
                id: d.email,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadContacts = async ( orgId, aid, uid, segment ) => {
    const endpoint = base + '/contacts?';
    let list = [];
    const id = ( [ 'leads', 'nurtures' ].includes( segment ) ) ? 'lorid' : 'cid';

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                orgId: orgId,
                aid: aid,
                uid: uid,
                segment: ( segment ) ? segment : 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d[id],
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadHomebotContactEvents = async ( aid, uid, cid ) => {
    const endpoint = base + '/homebot';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'contact-events',
                cid: cid
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.hid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadLoans = async ( aid, uid, segment ) => {
    const endpoint = base + '/loans?';
    let list = [];

	try {
        const resp = await fetchData( endpoint, {
            aid: aid,
            uid: uid,
            segment: ( segment ) ? segment : 'all'
        } );
		// const resp = await axios( endpoint, {
		// 	method: 'POST',
		// 	mode: 'no-cors',
        //     data: {
        //         aid: aid,
        //         uid: uid,
        //         segment: ( segment ) ? segment : 'all'
        //     },
        //     responseEncoding: 'gzip'
		// } );
        list = resp.map( d => { 
            return { 
                id: d.lid,
                ...d
            }; 
        } );
		console.log( aid, list );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadLoan = async ( aid, uid, lid ) => {
    const endpoint = base + '/loans?';
    let l = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                lid: lid,
                segment: 'single'
            },
            responseEncoding: 'gzip'
		} );
        console.log( resp );
        l = { ...resp.data };
        console.log( l );
	} catch ( e ) {
		console.log( e );
	}

    return l;
};

const loadLists = async ( aid, uid ) => {
    const endpoint = base + '/groups?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.gid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadList = async ( aid, uid, gid ) => {
    const endpoint = base + '/groups?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'group',
                gid: gid
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.grid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createList = async ( aid, uid, name, items, itemType ) => {
    const endpoint = base + '/groups?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-group',
                name: name,
                items: items,
                itemType: itemType
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.gid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const addItemsToLists = async ( aid, uid, gid, items, itemType ) => {
    const endpoint = base + '/groups?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'add-items',
                gid: gid,
                items: items,
                itemType: itemType
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.gid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeItemsFromList = async ( aid, uid, items, gid ) => {
    const endpoint = base + '/groups?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-items',
                gid: gid,
                items: items
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeLists = async ( aid, uid, gids ) => {
    const endpoint = base + '/groups?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-lists',
                gids: gids
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createLeadOpp = async ( aid, uid, desc, oppDate, purpose, source, status, relationships ) => {
    const endpoint = base + '/leadopps?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-leadopp',
                relationships: relationships,
                name: desc,
                oppDate: oppDate,
                purpose: purpose,
                source: source,
                status: status
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.loid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const createLeadOppRelationship = async ( aid, uid, loid, cid ) => {
    const endpoint = base + '/leadopps?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-relationship',
                loid: loid,
                cid: cid,
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.lorid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const deleteLeadOpp = async ( aid, uid, loid ) => {
    const endpoint = base + '/leadopps?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'delete-leadopp',
                loid: loid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const deleteLeadOppRelationship = async ( aid, uid, lorid ) => {
    const endpoint = base + '/leadopps?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'delete-relationship',
                lorid: lorid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const loadEvents = async ( aid, uid ) => {
    const endpoint = base + '/events?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.eid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadEvent = async ( aid, uid, eid ) => {
    const endpoint = base + '/events?';
    let e = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'event',
                eid: eid
            },
            responseEncoding: 'gzip'
		} );
        e = { id: eid, ...resp.data };
	} catch ( err ) {
		console.log( err );
	}

    return e;
};

const loadEventMembers = async ( aid, uid, eid ) => {
    const endpoint = base + '/events?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'event-members',
                eid: eid
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.eilid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadLeadOpps = async ( aid, uid ) => {
    const endpoint = base + '/leadopps?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => { 
            return { 
                id: d.loid,
                ...d
            }; 
        } );
		// console.log( list );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadLeadOpp = async ( aid, uid, loid ) => {
    const endpoint = base + '/contacts?';
    let e = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'leadopp',
                loid: loid
            },
            responseEncoding: 'gzip'
		} );
        e = { id: loid, ...resp.data };
	} catch ( err ) {
		console.log( err );
	}

    return e;
};

const loadTasks = async ( aid, uid ) => {
    const endpoint = base + '/tasks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.tid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadTodaysTasks = async ( aid, uid ) => {
    const endpoint = base + '/tasks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'today'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.tid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadTask = async ( aid, uid, tid ) => {
    const endpoint = base + '/tasks?';
    let t = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'task',
                tid: tid
            },
            responseEncoding: 'gzip'
		} );
        t = { id: tid, ...resp.data };
	} catch ( e ) {
		console.log( e );
	}

    return t;
};

const loadTaskAssocs = async ( aid, uid, tid ) => {
    const endpoint = base + '/tasks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'task-assocs',
                tid: tid
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.taid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadReviews = async ( aid, uid ) => {
    const endpoint = base + '/reviews?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.rid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadReview = async ( aid, uid, rid ) => {
    const endpoint = base + '/reviews?';
    let r = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'review',
                rid: rid
            },
            responseEncoding: 'gzip'
		} );
        r = { id: rid, ...resp.data };
	} catch ( e ) {
		console.log( e );
	}

    return r;
};

const loadReviewRelationships = async ( aid, uid, rid ) => {
    const endpoint = base + '/reviews?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'review-relationships',
                rid: rid
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.rrid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadGifts = async ( aid, uid ) => {
    const endpoint = base + '/gifts?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.gid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadGift = async ( aid, uid, gid ) => {
    const endpoint = base + '/gifts?';
    let g = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'gift',
                gid: gid
            },
            responseEncoding: 'gzip'
		} );
        g = { id: gid, ...resp.data };
	} catch ( e ) {
		console.log( e );
	}

    return g;
};

const loadGiftRecipients = async ( aid, uid, gid ) => {
    const endpoint = base + '/gifts?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'gift-recipients',
                gid: gid
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.grid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const addContactsToEvent = async ( aid, uid, eid, contacts ) => {
    const endpoint = base + '/events?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'add-contacts',
                eid: eid,
                contacts: contacts
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeContactsFromEvent = async ( aid, uid, contacts, eid ) => {
    const endpoint = base + '/events?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-contacts',
                eid: eid,
                contacts: contacts
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createEvent = async ( aid, uid, event, contacts ) => {
    const endpoint = base + '/events?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-event',
                event: event,
                contacts: contacts
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const search = async ( aid, uid ) => {
    const endpoint = base + '/search?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: ( d.cid ) ? d.cid : d.lid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const addBorrowersToLoan = async ( aid, uid, lid, borrowers ) => {
    const endpoint = base + '/loans?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'add-borrowers',
                lid: lid,
                borrowers: borrowers
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createLoan = async ( aid, uid, loan, borrowers, loid ) => {
    const endpoint = base + '/loans?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-loan',
                loan: loan,
                borrowers: borrowers,
                loid: loid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeLoan = async ( aid, uid, lid ) => {
    const endpoint = base + '/loans?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-loan',
                lid: lid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeBorrowersFromLoan = async ( aid, uid, lid, borrowers ) => {
    const endpoint = base + '/loans?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-borrowers',
                lid: lid,
                borrowers: borrowers
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createContact = async ( orgId, aid, uid, contact, seg = 'create-contact', cobo ) => {
    const endpoint = base + '/contacts?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                orgId: orgId,
                aid: aid,
                uid: uid,
                segment: seg,
                contact: contact,
                cobo: cobo
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createGift = async ( aid, uid, desc, reason, giftDate, price, details, contacts ) => {
    const endpoint = base + '/gifts?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-gift',
                name: desc,
                reason: reason,
                giftDate: giftDate,
                price: price,
                details: details,
                contacts: contacts
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeGift = async ( aid, uid, gid ) => {
    const endpoint = base + '/gifts?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-gift',
                gid: gid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createReview = async ( aid, uid, review, contacts, lid ) => {
    const endpoint = base + '/reviews?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-review',
                review: review,
                contacts: contacts,
                lid: lid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createTask = async ( aid, uid, task, assoc ) => {
    const endpoint = base + '/tasks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-task',
                task: task,
                assoc: assoc
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createNote = async ( aid, uid, note, contacts, lid ) => {
    const endpoint = base + '/notes?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-note',
                note: note,
                contacts: contacts,
                lid: lid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const update = async ( orgId, aid, uid, objType, oid, obj, shared = false ) => {
    const endpoint = base + '/update?';
    let list = [];
    const remove = [];

    console.log( 'updating: ', obj );
    const keys = Object.keys( obj );
    keys.forEach( f => {
        if ( typeof( obj[f] ) !== 'boolean' && ( !obj[f] || ( typeof( obj[f] ) === 'string' && !obj[f].length ) ) ) {
            delete obj[f];
            remove.push( f );
        }
    } );
    console.log( 'removing: ', remove );

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                orgId: orgId,
                aid: aid,
                uid: uid,
                segment: objType,
                oid: oid,
                shared: shared,
                obj: obj,
                remove: remove
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const updateMass = async ( uid, objType, oids, obj ) => {
    const endpoint = base + '/update?';
    let list = [];
    const remove = [];

    const keys = Object.keys( obj );
    keys.forEach( f => {
        if ( !obj[f] || ( typeof( obj[f] ) === 'string' && !obj[f].length ) ) {
            delete obj[f];
            remove.push( f );
        }
    } );
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                uid: uid,
                segment: objType,
                oids: oids,
                obj: obj,
                remove: remove
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const logCall = async ( aid, uid, call, contacts, lid  ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'log-call',
                contacts: contacts,
                call: call,
                lid: lid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const logEmail = async ( aid, uid, email, contacts, lid  ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'log-email',
                contacts: contacts,
                email: email,
                lid: lid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const logSms = async ( aid, uid, sms, contacts, lid  ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'log-sms',
                contacts: contacts,
                sms: sms,
                lid: lid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeTask = async ( aid, uid, tid ) => {
    const endpoint = base + '/tasks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-task',
                tid: tid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadNotes = async ( aid, uid ) => {
    const endpoint = base + '/notes?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.nid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadNote = async ( aid, uid, nid ) => {
    const endpoint = base + '/notes?';
    let n = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'note',
                nid: nid
            },
            responseEncoding: 'gzip'
		} );
        n = { id: nid, ...resp.data };
	} catch ( e ) {
		console.log( e );
	}

    return n;
};

const removeNote = async ( aid, uid, nid ) => {
    const endpoint = base + '/notes?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-note',
                nid: nid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeReview = async ( aid, uid, rid ) => {
    const endpoint = base + '/reviews?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-review',
                rid: rid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadGameplan = async ( aid, uid ) => {
    const endpoint = base + '/gameplan?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.gpid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadComms = async ( aid, uid, channel ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
        let resp = await fetchData( endpoint, {
            aid: aid,
            uid: uid,
            segment: 'all',
            channel: channel
        } );
		// let resp = await axios( endpoint, {
		// 	method: 'POST',
		// 	// mode: 'no-cors',
        //     data: {
        //         aid: aid,
        //         uid: uid,
        //         segment: 'all',
        //         channel: channel
        //     },
        //     responseEncoding: 'gzip'
		// } );
        list = resp.map( d => {
            return {
                id: d.cid,
                ...d
            };
        } );
        // while ( resp.headers['x-tf-next-index'] ) {
        //     console.log( 'fetching more comms - start index:', resp.headers['x-tf-next-index'] );
        //     resp = await axios( endpoint, {
        //         method: 'POST',
        //         data: {
        //             aid: aid,
        //             uid: uid,
        //             segment: 'all',
        //             channel: channel,
        //             startIndex: resp.headers['x-tf-next-index']
        //         },
        //         responseEncoding: 'gzip'
        //     } );
        //     list = [ ...list, ...resp.data.map( d => {
        //         return {
        //             id: d.cid,
        //             ...d
        //         };
        //     } ) ];
        // }
	} catch ( e ) {
		console.log( 'Comms error:', e );
        return null;
	}

    return list;
};

const markCommsProcessed = async ( aid, uid, cid ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                cid: cid,
                segment: 'mark-processed'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.cid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadMessages = async ( aid, uid ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		let resp = await axios( endpoint, {
			method: 'POST',
			// mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'all-messages'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.mid,
                ...d
            };
        } );
        while ( resp.headers['x-tf-next-index'] ) {
            console.log( 'fetching more messages - start index:', resp.headers['x-tf-next-index'] );
            resp = await axios( endpoint, {
                method: 'POST',
                data: {
                    aid: aid,
                    uid: uid,
                    segment: 'all-messages',
                    startIndex: resp.headers['x-tf-next-index']
                },
                responseEncoding: 'gzip'
            } );
            list = [ ...list, ...resp.data.map( d => {
                return {
                    id: d.mid,
                    ...d
                };
            } ) ];
        }
	} catch ( e ) {
		console.log( 'Messages error:', e );
        return null;
	}

    return list;
};

const sendSingleEmail = async ( aid, uid, msg ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'send-email',
                msg: msg
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const sendMassEmail = async ( aid, uid, msg ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'send-mass-email',
                msg: msg
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const sendSingleSms = async ( aid, uid, msg ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'send-sms',
                msg: msg
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const sendMassSms = async ( aid, uid, msg ) => {
    const endpoint = base + '/comms?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'send-mass-sms',
                msg: msg
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const genSignedUrl = async ( aid, uid, bucket, key, fileType, publicRead = false ) => {
    const endpoint = base + '/files?';
    let obj = {};

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'gen-signed-url',
                bucket: bucket,
                key: key,
                fileType: fileType,
                public: publicRead
            },
            responseEncoding: 'gzip'
		} );
        obj = resp.data;
	} catch ( e ) {
		console.log( e );
	}

    return obj;
};

const createFile = async ( aid, uid, file ) => {
    const endpoint = base + '/files?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-file',
                file: file
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeFile = async ( aid, uid, fid ) => {
    const endpoint = base + '/files?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-file',
                fid: fid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const loadFiles = async ( aid, uid, segment ) => {
    const endpoint = base + '/files?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: ( segment ) ? segment : 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.fid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const createRefOut = async ( aid, uid, ref ) => {
    const endpoint = base + '/refsout?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-ref',
                ref: ref
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadRefsOut = async ( aid, uid, segment ) => {
    const endpoint = base + '/refsout?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: ( segment ) ? segment : 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.roid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeRefsOut = async ( aid, uid, roid ) => {
    const endpoint = base + '/refsout?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-ref',
                roid: roid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const createOffer = async ( aid, uid, offer ) => {
    const endpoint = base + '/offers?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'create-offer',
                offer: offer
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadOffers = async ( aid, uid, segment ) => {
    const endpoint = base + '/offers?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: ( segment ) ? segment : 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.oid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const removeOffer = async ( aid, uid, oid ) => {
    const endpoint = base + '/offers?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'remove-offer',
                oid: oid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const removeContact = async ( orgId, aid, uid, cid, shared = false ) => {
    const endpoint = base + '/contacts?';
    let list = [];
    const seg = ( shared ) ? 'remove-org-contact' : 'remove-contact';
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                orgId: orgId,
                aid: aid,
                uid: uid,
                segment: seg,
                cid: cid
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const mergeContacts = async ( orgId, aid, uid, pri, sec, shared = false ) => {
    const endpoint = base + '/contacts?';
    let list = [];
    const seg = ( shared ) ? 'merge-org-contacts' : 'merge-contacts';
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                orgId: orgId,
                aid: aid,
                uid: uid,
                segment: seg,
                pri: pri,
                sec: sec
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
}

const loadPlaybooks = async ( aid, uid, segment ) => {
    const endpoint = base + '/playbooks?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			// mode: 'no-cors',
            withCredentials: false,
            data: {
                aid: aid,
                uid: uid,
                segment: ( segment ) ? segment : 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.pid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const changePlaybookStatus = async ( uid, pids, status ) => {
    const endpoint = base + '/playbooks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                uid: uid,
                segment: 'change-status',
                pids: pids,
                status: status
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const changePlaybookStepStatus = async ( uid, steps, status ) => {
    const endpoint = base + '/playbooks?';
    let list = [];

	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                uid: uid,
                segment: 'change-status-steps',
                steps: steps,
                status: status
            },
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const loadTemplates = async ( aid, uid, segment ) => {
    const endpoint = base + '/templates?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: ( segment ) ? segment : 'all'
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.tid,
                ...d
            };
        } );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const changePwd = async ( aid, uid, c, n ) => {
    const endpoint = base + '/login?';
    let changes = [];

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                curPwd: c,
                newPwd: n,
                action: 'pwd-change'
            }
		} );
        // console.log( resp );
        changes = ( resp.data && resp.data.body && resp.data.body.length ) ? JSON.parse( resp.data.body ) : [];
	} catch ( e ) {
		console.log( e );
	}

    return changes;
};

const askGPT = async ( aid, uid, prompt, promptType, formattedTo ) => {
    const endpoint = base + '/gpt?';
    let answer = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                prompt: prompt,
                segment: promptType,
                to: formattedTo
            }
		} );
        console.log( 'api resp: ', resp );
        answer = ( resp.data?.answer?.display ) ? resp.data.answer.display : '';
	} catch ( e ) {
		console.log( e );
	}

    return answer;
};

const getClientProfile = async ( aid, uid, profile, cid ) => {
    const endpoint = base + '/gpt?';
    let answer = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                profile: profile,
                segment: 'leo-client-profile',
                cid: cid
            }
		} );
        console.log( 'api resp: ', resp );
        answer = resp.data?.answer;
	} catch ( e ) {
		console.log( e );
	}

    return answer;
};

const getAIResponse = async ( aid, uid, msgs, prompt ) => {
    const endpoint = base + '/gpt?';
    let answer = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'leo-ask',
                msgs: msgs,
                prompt: prompt
            }
		} );
        console.log( 'api resp: ', resp );
        answer = resp.data?.answer;
	} catch ( e ) {
		console.log( e );
	}

    return answer;
};

const getAITranslation = async ( aid, uid, prompt ) => {
    const endpoint = base + '/gpt?';
    let answer = {};

	try {
        const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                uid: uid,
                segment: 'leo-translate',
                prompt: prompt
            }
		} );
        console.log( 'api resp: ', resp );
        answer = resp.data?.answer;
	} catch ( e ) {
		console.log( e );
	}

    return answer;
};

const createLetter = async ( aid, cid, lid, pa ) => {
    const endpoint = base + '/loans?';
    let list = [];
    
	try {
		const resp = await axios( endpoint, {
			method: 'POST',
			mode: 'no-cors',
            data: {
                aid: aid,
                cid: cid,
                segment: 'create-pa-letter',
                lid: lid,
                ...pa
            },
            responseEncoding: 'gzip'
		} );
        list = resp.data.map( d => {
            return {
                id: d.cid,
                ...d
            };
        } );
        console.log( 'created letter for: ', list );
	} catch ( e ) {
		console.log( e );
	}

    return list;
};

const fetchData = async ( endpoint, data ) => {
    let list = [];

	try {
        console.log( 'fetching:', data );
		let resp = await axios( endpoint, {
			method: 'POST',
			data: data,
            responseEncoding: 'gzip'
		} );
        list = [ ...resp.data ];

        while ( resp.headers['x-tf-next-index'] ) {
            console.log( 'fetching more data - start index:', resp.headers['x-tf-next-index'] );
            resp = await axios( endpoint, {
                method: 'POST',
                data: {
                    ...data,
                    startIndex: resp.headers['x-tf-next-index']
                },
                responseEncoding: 'gzip'
            } );
            list = [ ...list, ...resp.data ];
        }
	} catch ( e ) {
		console.log( 'fetchData error:', e );
        return null;
	}

    return list;
};

export { 
    login,
    reload,
    restore,
    loadAccounts, 
    loadContacts, 
    loadHomebotContactEvents,
    loadLoans, 
    loadLoan,
    loadLists,
    loadList,
    addItemsToLists,
    createList,
    removeItemsFromList,
    removeLists,
    createLeadOpp,
    createLeadOppRelationship,
    deleteLeadOpp,
    deleteLeadOppRelationship,
    loadEvents,
    loadEvent,
    loadEventMembers,
    loadLeadOpps,
    loadLeadOpp,
    loadTasks,
    loadTodaysTasks,
    loadTask,
    loadTaskAssocs,
    loadReviews,
    loadReview,
    loadReviewRelationships,
    loadGifts,
    loadGift,
    loadGiftRecipients,
    addContactsToEvent,
    removeContactsFromEvent,
    createEvent,
    search,
    addBorrowersToLoan,
    createLoan,
    removeLoan,
    removeBorrowersFromLoan,
    createContact,
    createGift,
    removeGift,
    createReview,
    createTask,
    createNote,
    logCall,
    logEmail,
    logSms,
    update,
    updateMass,
    removeTask,
    loadNotes,
    loadNote,
    removeNote,
    removeReview,
    loadGameplan,
    loadComms,
    loadMessages,
    sendSingleEmail,
    sendMassEmail,
    sendSingleSms,
    sendMassSms,
    genSignedUrl,
    createFile,
    removeFile,
    loadFiles,
    createRefOut,
    loadRefsOut,
    removeRefsOut,
    createOffer,
    loadOffers,
    removeOffer,
    removeContact,
    mergeContacts,
    loadPlaybooks,
    changePlaybookStatus,
    changePlaybookStepStatus,
    loadTemplates,
    changePwd,
    askGPT,
    getClientProfile,
    getAIResponse,
    getAITranslation,
    createLetter,
    loadUsers,
    markCommsProcessed
};